<template>
    <flex-element :element-type="elementType" tag="li">
        <component
            :is="elements[0].elementType"
            v-if="elements[0]"
            class-default="f-w-1/1"
            v-bind="element(1)"
            @element-updated="elementUpdated"
            @delete-element="deleteElement"
        />
    </flex-element>
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-smart';

export default {
    mixins: [baseOrganism],

    props: {
        displayName: {
            type: String,
            default: 'Collection Item',
        },

        index: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            cssDisplay: 'block',
        };
    },

    watch: {
        htmlClass() {
            this.$emit('classes-updated', this.htmlClass);
        },
    },

    methods: {
        deleteElement(index) {
            this.$parent.$emit('delete-element', index);
        },
    },
};
</script>
